// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"c34c919f","382":"a1c138da","559":"828151e1"}[chunkId] + ".chunk.js";
};